import ApiService from '../apiservice'

export default class UploadService extends ApiService {

  constructor() {
    super('upload');
  }

  upload(formData) {
    return this.post('/',formData);
  }
}